<script lang="ts" setup>
import {onMounted, watch} from "vue";
import {useSignalRStore} from "@/stores/signalr/signalr-store";
import {useAuthStore} from "@/stores/authentication-store";
import {useNavigationStore} from "@/stores/navigation-store";

const authStore = useAuthStore();
const navigationStore = useNavigationStore();

onMounted(async () => {
  await authStore.ensureHydrated();
  if (authStore.isAuthenticated()) {
    await useSignalRStore().Connect()
  }
});

//Make sure SignalR is connected whenever the path changes
watch(() => navigationStore.currentPageTranslationLabel, async (_) => {
  await useSignalRStore().Connect()
})
</script>

<template>

</template>

<style lang="scss" scoped>

</style>
